import React from 'react';
import { Helmet } from 'react-helmet-async';
import Footer from '../components/Footer';

const AydinlatmaMetni = () => {
  return (
    <>
      <Helmet>
        <title>Müşteri Kişisel Verilerinin İşlenmesi Aydınlatma Metni - SigortamOlsun</title>
        <meta name="description" content="SigortamOlsun Müşteri Kişisel Verilerinin İşlenmesi Aydınlatma Metni" />
      </Helmet>

      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-purple-50">
        <div className="container mx-auto px-4 py-12">
          <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-lg p-8">
            <h1 className="text-3xl font-bold text-gray-800 mb-6">
              SİGORTAMOLSUN SİGORTA ARACILIK HİZMETLERİ LTD. ŞTİ. MÜŞTERİ KİŞİSEL VERİLERİNİN İŞLENMESİ AYDINLATMA METNİ
            </h1>

            <div className="prose prose-blue max-w-none">
              <div className="bg-gray-50 p-6 rounded-lg mb-8">
                <p className="text-gray-600">
                  İşbu Aydınlatma Metni, veri sorumlusu sıfatıyla hareket eden SİGORTAMOLSUN SİGORTA ARACILIK HİZMETLERİ LTD. ŞTİ. ("Şirket") tarafından, 6698 sayılı Kişisel Verilerin Korunması Kanunu ("Kanun") uyarınca, aşağıda belirtilen amaçlarla toplanan kişisel verilere ilişkin olarak sigortalıların ve sigorta ettirenler dahil tüm müşterilerin aydınlatılması amacıyla kaleme alınmıştır.
                </p>
              </div>

              <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">
                Hangi Kişisel Verilerin İşleneceği
              </h2>
              <div className="space-y-4">
                <div className="bg-white p-4 rounded-lg border border-gray-200">
                  <h3 className="font-semibold text-gray-700 mb-2">Kimlik Verileri</h3>
                  <p className="text-gray-600">Ad, soyad, T.C. kimlik numarası, doğum tarihi, doğum yeri, medeni durum, cinsiyet, pasaport numarası, anne - baba adı, anne kızlık soyadı, nüfus cüzdanı</p>
                </div>

                <div className="bg-white p-4 rounded-lg border border-gray-200">
                  <h3 className="font-semibold text-gray-700 mb-2">İletişim Verileri</h3>
                  <p className="text-gray-600">Adres, telefon numarası, e-postası adresi, kayıtlı elektronik posta adresi (KEP)</p>
                </div>

                <div className="bg-white p-4 rounded-lg border border-gray-200">
                  <h3 className="font-semibold text-gray-700 mb-2">Finansal Veriler</h3>
                  <p className="text-gray-600">Banka hesap bilgileri, kredi kartı bilgisi (CVV numarası dahil), maaş bilgileri</p>
                </div>

                <div className="bg-white p-4 rounded-lg border border-gray-200">
                  <h3 className="font-semibold text-gray-700 mb-2">Mesleki Veriler</h3>
                  <p className="text-gray-600">Çalıştığı şirket, çalıştığı departman, meslek, meslek kartı bilgileri</p>
                </div>

                <div className="bg-white p-4 rounded-lg border border-gray-200">
                  <h3 className="font-semibold text-gray-700 mb-2">Özel Nitelikli Veriler</h3>
                  <p className="text-gray-600">Sağlık verileri, din bilgisi, kan grubu, biyometrik veriler</p>
                </div>

                <div className="bg-white p-4 rounded-lg border border-gray-200">
                  <h3 className="font-semibold text-gray-700 mb-2">Müşteri İşlem Verileri</h3>
                  <p className="text-gray-600">Çağrı merkezi kayıtları, fatura bilgileri, sipariş bilgileri, poliçe bilgileri</p>
                </div>
              </div>

              <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">
                Kişisel Verilerin İşlenme Amaçları
              </h2>
              <ul className="list-disc pl-6 text-gray-600 space-y-2">
                <li>Sigorta poliçelerinin hazırlanması ve yönetimi</li>
                <li>Müşteri ilişkileri yönetimi</li>
                <li>Risk değerlendirmesi ve yönetimi</li>
                <li>Yasal yükümlülüklerin yerine getirilmesi</li>
                <li>Hasar yönetimi süreçlerinin yürütülmesi</li>
                <li>Pazarlama ve tanıtım faaliyetlerinin yürütülmesi</li>
              </ul>

              <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">
                Kişisel Verilerin Aktarılması
              </h2>
              <p className="text-gray-600 mb-4">
                Kişisel verileriniz, aşağıdaki taraflarla paylaşılabilir:
              </p>
              <ul className="list-disc pl-6 text-gray-600 space-y-2">
                <li>Sigorta şirketleri</li>
                <li>Yasal düzenleyici kurumlar</li>
                <li>Hizmet sağlayıcılar ve iş ortakları</li>
                <li>Reasürans şirketleri</li>
              </ul>

              <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">
                Kişisel Veri Sahibi Olarak Haklarınız
              </h2>
              <div className="bg-blue-50 p-6 rounded-lg">
                <p className="text-gray-700 mb-4">
                  KVKK'nın 11. maddesi uyarınca aşağıdaki haklara sahipsiniz:
                </p>
                <ul className="list-disc pl-6 text-gray-700 space-y-2">
                  <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme</li>
                  <li>Kişisel verileriniz işlenmişse bilgi talep etme</li>
                  <li>Kişisel verilerinizin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme</li>
                  <li>Kişisel verilerinizin düzeltilmesini veya silinmesini talep etme</li>
                  <li>İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle aleyhinize bir sonucun ortaya çıkmasına itiraz etme</li>
                </ul>
              </div>

              <div className="bg-blue-50 p-6 rounded-lg mt-8">
                <h2 className="text-xl font-semibold text-blue-800 mb-4">
                  İLETİŞİM BİLGİLERİ
                </h2>
                <ul className="text-gray-700 space-y-2">
                  <li>E-posta: info@sigortamolsun.com</li>
                  <li>Web: www.sigortamolsun.com</li>
                  <li>Mersis No: 0770099257700001</li>
                  <li>Adres: Ünsal, 5088. Sk. No: 22, 07080 Kepez/Antalya</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default AydinlatmaMetni;